import type { RecordLikeProtocol, RichTextContentProtocol, VariableADTvalue } from '@lighthouse/core'
import { VariableType } from '@lighthouse/core'
import { fieldConvertValue, generateText, useApplicationContext } from '@lighthouse/shared'
import { useCallback } from 'react'

import { usePageDataQueryVariableLabel } from '@/hooks/usePageDataQueryVariableLabel'
import { useParseVariableWithSubscription } from '@/hooks/useParseVariable'

export const useRenderRichText = (richText?: RichTextContentProtocol | RichTextContentProtocol[]) => {
    const { personOptions, roleOptions, departmentOptions } = useApplicationContext()
    const parseVariable = useParseVariableWithSubscription(richText)
    const getPageDataQueryVariableLabel = usePageDataQueryVariableLabel()
    const parseVariable2String = useCallback(
        (v: VariableADTvalue | undefined, record?: RecordLikeProtocol) => {
            const field = parseVariable(v, {
                viewRecord: record
            })
            if (!field) {
                if (v?.type === VariableType.PAGE_DATA_QUERY) {
                    return getPageDataQueryVariableLabel(v)
                }
                return ''
            }
            return fieldConvertValue(field, { personOptions, roleOptions, departmentOptions })
        },
        [parseVariable, personOptions, roleOptions, departmentOptions, getPageDataQueryVariableLabel]
    )

    return useCallback(
        (v: RichTextContentProtocol, record?: RecordLikeProtocol) => {
            return generateText(v, {
                variable: {
                    renderLabel: v => parseVariable2String(v.attrs.value, record)
                }
            })
        },
        [parseVariable2String]
    )
}
